import type { ViewTypes } from 'src/helper/shared-types';

export const WQ_DATA_KEYS = {
  ID: 'notification_id',
  ADDRESS: 'address',
  MARKET: 'market',
  MESSAGE: 'message',
  SRWOID: 'sr_wo_id',
  STATUS: 'status',
  TIME: 'time',
  ACTION: 'actions',
} as const;

export const WQ_DATA_LABELS = {
  ADDRESS: 'Address',
  MARKET: 'Market',
  MESSAGE: 'Notification',
  SRWOID: 'SR/WO ID',
  STATUS: 'SR/WO Status',
  TIME: 'Time',
} as const;

export const WQ_COLUMN_TYPES = {
  ADDRESS: 'workQueueAddress',
  MARKET: 'market',
  MESSAGE: 'workQueueType',
  SRWOID: 'workQueueID',
  STATUS: 'workQueueStatus',
  TIME: 'workQueueTime',
  ACTIONS: 'workQueueActions',
} as const;

export const WQ_PAGE_TITLE: string = 'Work Queue';

/**
 * Rows per page for the Work Queue list — the value the client has always sent
 * as `per_page`, named here so the server-side read (APX-522) uses the same
 * number rather than a second literal.
 *
 * NOT YET A SINGLE SOURCE, and the difference matters. The only consumers today
 * are this declaration and `src/server/work-queue-rows.ts`; the client still
 * carries the literal `25` at its own call sites (`src/views/WorkQueue/Listing.tsx`
 * and `ListingComponentV2`'s infinite-scroll payload). Routing those through this
 * constant belongs with APX-543, which is the ticket that actually needs the two
 * sides to agree — doing it here would change client request payloads while the
 * pilot flag is still OFF.
 *
 * This is a HARD CAP, not a tunable. `ListingComponentV2` switches to row
 * virtualization at 50 rows and a virtualized first render emits one spacer
 * `<tr>` and ZERO data rows, so a server-rendered page of >= 50 rows ships a
 * blank table. Raising this past 25 requires solving SSR virtualization first.
 */
export const WQ_PAGE_SIZE: number = 25;

export const WQ_PRIMARY_KEY: string = WQ_DATA_KEYS.ID;

/**
 * The `data-testid` prefix every Work Queue row and cell is emitted under by
 * `ListingComponentV2` (`{prefix}-{id}` for the row, `{prefix}-{id}-cell-{key}` for
 * each cell). Exported so tests assert against the same literal the view passes
 * instead of re-typing it: the previous hard-coded copy in the view silently
 * diverged from the copy in the SSR suite, which then counted a test id the table
 * had stopped emitting and read the resulting 0 as "the seeded rows do not render".
 */
export const WQ_ROW_TESTID_PREFIX: string = 'work-queue-row';

export const WQ_TABS_KEYS = {
  ALL: 'all',
  CLEARED: 'cleared',
} as const;

export const WQ_TABLE_ID: string = 'workQueueTable';

export const WQ_VIEW_TYPE: ViewTypes = 'work-queues';

export const WQ_TABS_MAPPING = [
  {
    key: 'all',
    label: 'All Notifications',
  },
  {
    key: 'cleared',
    label: 'Cleared',
  },
];
